/**
 * Determines whether production logging should be enabled based on environment variables.
 *
 * @param {boolean | string | undefined} enableProdLoggingEnv - The value of NEXT_PUBLIC_ENABLE_PROD_LOGGING environment variable
 * @param {string | undefined} nodeEnv - The value of NODE_ENV environment variable
 * @returns {boolean} boolean indicating whether production logging should be enabled
 *
 * @example
 * // Enable production logging explicitly
 * shouldEnableProdLogging('true', 'development') // returns true
 *
 * // Disable production logging explicitly
 * shouldEnableProdLogging(false, 'production') // returns false
 *
 * // Use default behavior (based on NODE_ENV)
 * shouldEnableProdLogging(undefined, 'production') // returns true
 * shouldEnableProdLogging(undefined, 'development') // returns false
 */
export function shouldEnableProdLogging(enableProdLoggingEnv, nodeEnv) {
  // If explicitly set, use that value
  if (enableProdLoggingEnv !== undefined) {
    return typeof enableProdLoggingEnv === 'boolean'
      ? enableProdLoggingEnv
      : enableProdLoggingEnv === 'true';
  }

  // Otherwise, default to production behavior
  return nodeEnv === 'production';
}
